//this file is auto-generated with the `setup` script.js
module.exports = ["/en-CA/partners/kpmg-trip-may2020-signup/","/404/*","/en-CA/partners/virgin-scholarship-trip-2020/","/en-CA/events-lead/","/en-CA/partners/nutrien-employee-trip-backup/"]
